import React from 'react';
import { withProps } from 'recompose';
import PropTypes from 'prop-types';

import { generateCyElemId } from 'moet-test-utils/cypress/utils';

import { CY_APPLICANT_CONTAINER_IDS, MIN_AGE, T_PREFIX } from './constants';
import { ApplicantSelectorLabel } from './ApplicantSelectorLabel';
import { MultiSelector } from './MultiSelector';

const { INPUT_APPLICANT_CHECKBOX } = CY_APPLICANT_CONTAINER_IDS;

export const _ApplicantSelector = ({
  isDisabled = false,
  minAge = MIN_AGE,
  onChange = () => null,
  selectedIds = [],
  stakeholders = [],
  t = () => [],
}) => {
  if (stakeholders.length === 0) {
    return null;
  }

  const options = stakeholders.map(({ id, isOldEnough, ...stakeholderData }) => ({
    value: id,
    label: <ApplicantSelectorLabel {...stakeholderData} />,
    isDisabled: !isOldEnough || isDisabled,
    tooltipText: !isOldEnough ? t(`${T_PREFIX}.error_tooltip.too_young`, { minAge }) : undefined,
    extraProps: { ...generateCyElemId(INPUT_APPLICANT_CHECKBOX, window) },
  }));

  return <MultiSelector values={selectedIds} options={options} onChange={onChange} />;
};

_ApplicantSelector.propTypes = {
  stakeholders: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  minAge: PropTypes.number,
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

export const ApplicantSelector = withProps(({ stakeholders = [] }) => ({
  // Sort stakeholders by first name
  stakeholders: [...stakeholders].sort((stakeholder1, stakeholder2) =>
    stakeholder1.firstName.localeCompare(stakeholder2.firstName),
  ),
}))(_ApplicantSelector);
